module.exports = __webpack_public_path__ + "img/icon_2_18.3c93b854.png";